import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function EditResignationModal({ show, handleClose, data }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Resignation</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Employee</Form.Label>
            <Form.Control defaultValue={data?.name} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Reason</Form.Label>
            <Form.Control defaultValue={data?.reason} />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange">Save</Button>
      </Modal.Footer>
    </Modal>
  );
}